/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { HistoryItem } from 'client-code/recordings';

import { Mousetrap } from '../../../../common';
import { Spinner } from '../../../../VideoPlayerUI/Spinner';
import { isGroupHeader } from '../RecordingActivity.utils';
import RecordingActivityHeader from './RecordingActivityHeader/RecordingActivityHeader';
import RecordingActivityOfferItem from './RecordingActivityOfferItem/RecordingActivityItem';

import './RecordingActivityContent.scss';

export type RecordingActivityProps = {
    items: HistoryItem[];
    currentPage: number;
};

const RecordingActivity = ({ items, currentPage }: RecordingActivityProps) => {
    const displaySpinner = items.length === 0 && currentPage !== 0;

    const createRecordingActivityRender = () => {
        let rowIndex = 0;

        return items.reduce<JSX.Element[]>((acc, item) => {
            if (isGroupHeader(item)) {
                acc.push(
                    <Mousetrap value={item.name} key={item.name}>
                        <RecordingActivityHeader key={item.name} header={item} />
                    </Mousetrap>,
                );
            } else {
                acc.push(
                    <RecordingActivityOfferItem
                        key={`${item.contentId}--${rowIndex}`}
                        item={item}
                        rowIndex={rowIndex}
                    />,
                );
                rowIndex += 1;
            }
            return acc;
        }, []);
    };

    return (
        <div className="recording-activity-list-content">
            {displaySpinner ? (
                <div className="recording-activity-list-spinner">
                    <Spinner message="" />
                </div>
            ) : (
                createRecordingActivityRender()
            )}
        </div>
    );
};

export default RecordingActivity;
